export var UniversNetworkLinkDetail;
(function (UniversNetworkLinkDetail) {
    let type;
    (function (type) {
        type["OWN"] = "own";
        type["COMPETITOR"] = "competitor";
        type["ATTRACTOR"] = "attractor";
        type["INFO"] = "info";
    })(type = UniversNetworkLinkDetail.type || (UniversNetworkLinkDetail.type = {}));
})(UniversNetworkLinkDetail || (UniversNetworkLinkDetail = {}));
